import React from "react";
import { Card, Button, Input } from "components/ui";
import {
  ClockIcon,
  InformationCircleIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import { getUniqueFields, getCategoryConfig, getFieldIcon } from "../LeadDetails/DocumentsTab/utils/LeadUtils";
import { PencilIcon } from "@heroicons/react/24/solid";

/**
 * Main Component: Lead Details Form
 */
const LeadDetailsForm = ({
  isEditing,
  setIsEditing,
  loading,
  handleSave,
  leadData,
  onOpenQuickLeadModal,
  onOpenNotesModal,
  leadId
}) => {
  return (
    <div>
      {/* Header */}
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h2 className="dark:text-dark-50 text-lg font-semibold text-gray-900">
            Lead Details
          </h2>
          <p className="dark:text-dark-300 mt-1 text-sm text-gray-500">
            Information provided by the lead
          </p>
        </div>
        {/* <Button
          onClick={() => setIsEditing(!isEditing)}
          variant={isEditing ? "outlined" : "soft"}
          color={isEditing ? "warning" : "primary"}
          className="flex items-center gap-2"
        >
          <PencilIcon className="h-4 w-4" />
          {isEditing ? "Cancel Edit" : "Edit Lead"}
        </Button> */}
        <div className="flex items-center gap-2">
          <Button
            onClick={() => onOpenNotesModal?.()}
            disabled={leadData?.IsStudent}
            variant="soft"
            color="success"
            className={`flex items-center gap-2 ${leadData?.IsStudent ? "opacity-60 cursor-not-allowed" : ""}`}
          >
            <PlusIcon className="h-4 w-4" />
            Add Note
          </Button>
          <Button
            onClick={() => onOpenQuickLeadModal()}
            disabled={leadData?.IsStudent}
            variant="soft"
            color="primary"
            className={`flex items-center gap-2 ${leadData?.IsStudent ? "opacity-60 cursor-not-allowed" : ""}`}
          >
            <PencilIcon className="h-4 w-4" />
            Edit Lead
          </Button>
        </div>

      </div>

      <div className="space-y-8">
        <div className="space-y-8">
          {/* ========== Map Over LeadFieldCategories ========== */}
          {leadData?.LeadFieldCategories?.length > 0 ? (
            leadData.LeadFieldCategories.map((category) => {
              const config = getCategoryConfig(category.CategoryName);
              const Icon = config.icon;
              const uniqueFields = getUniqueFields(category.Fields);

              // Skip empty categories
              if (uniqueFields.length === 0) return null;

              return (
                <div key={category.CategoryId}>
                  {/* Category Header */}
                  <h3 className="text-md dark:text-dark-50 mb-4 flex items-center gap-2 font-semibold text-gray-900">
                    <span
                      className={`flex h-6 w-6 items-center justify-center rounded-full ${config.bgClass}`}
                    >
                      <Icon className={`h-4 w-4 ${config.iconClass}`} />
                    </span>
                    {category.CategoryName}
                  </h3>

                  {/* Fields Grid */}
                  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                    {uniqueFields.map((field, index) => {
                      const FieldIcon = getFieldIcon(field.FieldName);

                      return (
                        <Input
                          key={`${field.MasterFieldId}-${index}`}
                          label={field.FieldLabel}
                          value={field.FieldValue || ""}
                          disabled={!isEditing}
                          prefix={<FieldIcon className="h-4 w-4" />}
                          description={
                            isEditing
                              ? `Edit ${field.FieldLabel.toLowerCase()}`
                              : ""
                          }
                        />
                      );
                    })}
                  </div>
                </div>
              );
            })
          ) : (
            // Empty State
            <Card className="dark:bg-dark-800/50 bg-gray-50 p-8 text-center">
              <InformationCircleIcon className="mx-auto h-12 w-12 text-gray-400" />
              <p className="dark:text-dark-300 mt-2 text-sm text-gray-500">
                No lead data available
              </p>
            </Card>
          )}

          {/* ========== Save / Cancel Panel ========== */}
          {isEditing && (
            <Card className="dark:bg-dark-800/50 border-dashed bg-gray-50 p-4">
              <div className="flex items-center justify-between">
                <div className="dark:text-dark-300 flex items-center gap-2 text-sm text-gray-600">
                  <ClockIcon className="h-4 w-4" />
                  <span>You have unsaved changes</span>
                </div>
                <div className="flex gap-3">
                  <Button
                    onClick={handleSave}
                    variant="filled"
                    color="primary"
                    isGlow
                    disabled={loading || leadData?.IsStudent}
                    className="min-w-32"
                  >
                    {loading ? "Saving..." : "Save Changes"}
                  </Button>
                  <Button
                    onClick={() => setIsEditing(false)}
                    variant="outlined"
                    color="neutral"
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </Card>
          )}
        </div>
      </div>
    </div>
  )
};

export default LeadDetailsForm;
